import React from "react"
import {
    Box,
    componentStyles,
    HorizontalStack,
    HeadingMedium,
    useTheme,
    TextSmallSecondary,
} from "@mallardbay/lib-react-components"

import Avatar from "~components/shared/todo-lib-react-components/avatar"
import type { BlogEntryType, BlogEntryAuthorType } from "~utils/blog-helpers"
import { formatBlogEntryDate } from "~utils/date-helpers"
import { TEST_IDS } from "~config/test-ids"

type Props = {
    readonly blogEntry: BlogEntryType
    readonly blogEntryAuthor: BlogEntryAuthorType
}

export default function BlogEntryAuthor({ blogEntry, blogEntryAuthor }: Props) {
    const styles = useStyles()
    if (!blogEntry || !blogEntryAuthor?.data) return null
    const { name, avatar } = blogEntryAuthor.data

    if (!name || !avatar) return null

    const blogDate = formatBlogEntryDate(blogEntry.data?.postDate)

    return (
        <HorizontalStack style={styles.authorContainer}>
            <Avatar src={avatar} />
            <Box>
                <HeadingMedium>{name}</HeadingMedium>
                {blogDate && (
                    <TextSmallSecondary data-testid={TEST_IDS.BLOG_ENTRY_DATE}>
                        <span>{blogDate}</span>
                    </TextSmallSecondary>
                )}
            </Box>
        </HorizontalStack>
    )
}

function useStyles() {
    const theme = useTheme()
    const sharedSpacing = theme.space[5]

    return componentStyles({
        authorContainer: {
            marginTop: sharedSpacing,
            marginBottom: sharedSpacing,
        },
        authorImage: {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "100%",
        },
        authorName: {
            fontSize: "17px",
        },
        authorSecondary: {
            fontSize: "14px",
        },
    })
}
